import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M33.08 112.73a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M103.16 67.91a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M16.89 10.55h-5.57V4.98c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H2.75c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M106.66 52.4c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M58 18.32h28.54c4.5 0 8.14 3.65 8.14 8.14v68.9c0 4.5-3.64 8.14-8.14 8.14H29.45c-4.5 0-8.14-3.64-8.14-8.14V26.47c0-4.5 3.65-8.14 8.14-8.14H58"
    />
    <path
      fill="#001A43"
      d="m41.47 42.11 4.56-4.56c.88-.88.88-2.3 0-3.18s-2.3-.88-3.18 0l-4.56 4.56-4.56-4.56c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18l4.56 4.56-4.56 4.56a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66l4.56-4.56 4.56 4.56c.44.44 1.02.66 1.59.66a2.25 2.25 0 0 0 1.59-3.84zM79.22 85.82l4.56-4.56c.88-.88.88-2.3 0-3.18s-2.3-.88-3.18 0l-4.56 4.56-4.56-4.56c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18l4.56 4.56-4.56 4.56c-.88.88-.88 2.3 0 3.18.44.44 1.01.66 1.59.66s1.15-.22 1.59-.66L76.04 89l4.56 4.56c.44.44 1.01.66 1.59.66s1.15-.22 1.59-.66c.88-.88.88-2.3 0-3.18z"
    />
    <path
      fill="#D8FFFF"
      d="m84.98 41.54-7.22-8.62c-.45-.53-1.13-.84-1.81-.8-.7.03-1.34.38-1.75.94l-6.15 8.62c-.72 1.01-.49 2.42.53 3.14.4.28.85.42 1.3.42.7 0 1.39-.33 1.83-.94l2.07-2.9v10.32c0 3.23-2.63 5.86-5.86 5.86H50.05c-6.81 0-12.36 5.54-12.36 12.36v9c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-9c0-4.33 3.53-7.86 7.86-7.86h17.87c5.71 0 10.36-4.65 10.36-10.36V40.56l3.24 3.87a2.251 2.251 0 0 0 3.45-2.89z"
    />
    <path
      fill="#001A43"
      d="M39.96 94.95c-5.04 0-9.13-4.1-9.13-9.13s4.1-9.13 9.13-9.13 9.13 4.1 9.13 9.13-4.1 9.13-9.13 9.13m0-13.77a4.64 4.64 0 0 0-4.63 4.63 4.64 4.64 0 0 0 4.63 4.63 4.64 4.64 0 0 0 4.63-4.63 4.64 4.64 0 0 0-4.63-4.63"
    />
    <path
      fill="#0597A3"
      d="M68.74 11.51h-3.92c0-3.76-3.05-6.82-6.82-6.82s-6.82 3.05-6.82 6.82h-3.92c-4.03 0-7.31 3.27-7.31 7.31 0 4.03 3.27 7.31 7.31 7.31h21.47c4.04 0 7.31-3.27 7.31-7.31 0-4.03-3.27-7.31-7.31-7.31zM58 14.05a2.95 2.95 0 1 1 0-5.9 2.95 2.95 0 1 1 0 5.9"
    />
  </svg>
);
const SvgEnrichedIconStrategyBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconStrategyBrand);
export default Memo;
